// Links shared by the signed-out navbar, footer and product pages.
import { faClapperboard, faCode, faComment, faUpload } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

// blurb: one line for menus; summary: a sentence for cards. developer: the API, which has its own page layout and
// home section, so the grids of app products (home, product pages) leave it out.
export const PRODUCTS = [
  {
    to: '/workspace-feature',
    title: 'Workspaces',
    blurb: 'Chat with your videos.',
    summary: 'Upload, organize, and interact with your video content, whether from YouTube or local files.',
    icon: faComment,
  },
  {
    to: '/creator-feature',
    title: 'Creator Studio',
    blurb: 'Upload videos and publish on YouTube.',
    summary: 'Manage, optimize, and elevate your video content as a Bumpups Creator.',
    icon: faClapperboard,
  },
  {
    to: '/youtube-feature',
    title: 'YouTube Videos',
    blurb: 'Process YouTube videos on Bumpups.',
    summary: 'Paste a link to any public YouTube video and get insights in minutes.',
    icon: faYoutube,
  },
  {
    to: '/local-feature',
    title: 'Local Videos',
    blurb: 'Process local videos on Bumpups.',
    summary: 'Upload MP4, MOV or WebM files up to 16 GB, in SD, HD or 4K.',
    icon: faUpload,
  },
  {
    to: '/developers',
    title: 'API',
    blurb: 'Chapters and answers from your own code.',
    summary: 'Send a YouTube link from your code and get chapters back, then ask questions about the video.',
    icon: faCode,
    developer: true,
  },
];

export const APP_PRODUCTS = PRODUCTS.filter(p => !p.developer);

export const SALES_FORM_URL = 'https://forms.gle/syyzvT25DsQ6yfZq5';

export const SOCIALS = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/bumpups', icon: faLinkedin },
  { label: 'X', href: 'https://x.com/bumpups', icon: faXTwitter },
  { label: 'YouTube', href: 'https://www.youtube.com/@bumpupsapp', icon: faYoutube },
];
